import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Button } from '@knowledgehound/laika'

import * as styles from './ModalControls.module.scss'

const propTypes = {
  onCancel: PropTypes.func.isRequired,
  submitDisabled: PropTypes.bool.isRequired,
}

const ModalControls = ({ onCancel, submitDisabled }) => {
  const intl = useIntl()

  return (
    <section className={styles.modalControls}>
      <Button variant="text" onClick={onCancel}>
        {intl.formatMessage({ id: 'global.cancel' })}
      </Button>
      <Button
        variant="primary"
        type="submit"
        disabled={submitDisabled}
        onClick={() => {}}
      >
        {intl.formatMessage({ id: 'addToStory.addToStory' })}
      </Button>
    </section>
  )
}

ModalControls.propTypes = propTypes

export default ModalControls
